import { Link } from 'react-router-dom';

export default function BookingCTA() {
  return (
    <section className="py-24 relative overflow-hidden" style={{ backgroundColor: '#1A5F5F' }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
          Ready to Start Your Recovery?
        </h2>
        <p className="text-xl text-teal-100 mb-10 max-w-2xl mx-auto">
          Book your appointment today and take the first step towards better health and wellness. Our team is ready to help you achieve your goals.
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          <Link
            to="/booking"
            className="whitespace-nowrap inline-flex items-center px-10 py-5 rounded-full font-semibold text-white text-lg transition-all hover:shadow-2xl hover:scale-105 cursor-pointer"
            style={{ backgroundColor: '#FF6B6B' }}
          >
            <i className="ri-calendar-line mr-3 text-2xl"></i>
            Book Appointment
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h4 className="text-white font-semibold mb-2">Flexible Hours</h4>
            <p className="text-teal-100 text-sm">Mon–Sat appointments, including Saturday mornings</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h4 className="text-white font-semibold mb-2">Insurance Accepted</h4>
            <p className="text-teal-100 text-sm">We work with major health insurance providers</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-heart-line text-3xl text-white"></i>
            </div>
            <h4 className="text-white font-semibold mb-2">Personalized Care</h4>
            <p className="text-teal-100 text-sm">Treatment plans tailored to your needs</p>
          </div>
        </div>
      </div>
    </section>
  );
}
